<template>
    <div class="d-block ddlightdark pt-2 pb-1 px-3" style="width: 100%;">
        <v-row no-gutters justify="space-between">
            <v-col :class="{ 'text-center': bigHeader, 'text-h5': bigHeader}">
                <span :class="[important ? 'blue--text' : 'ddwhite--text', 'card-title']">{{ title }}</span>
            </v-col>
            <v-col cols="auto" v-if="info">
                <v-tooltip v-model="show" bottom color="grey darken-3">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon x-small v-bind="attrs" v-on="on">
                            <v-icon color="ddgrey">mdi-information-outline</v-icon>
                        </v-btn>
                    </template>
                    <span class="d-inline-block content" style="max-width: 300px">{{ info }}</span>
                </v-tooltip>
            </v-col>
        </v-row>
    </div>
</template>

<script>

/**
 * WidgetHeader component shows the Widget element title and allows to show a 
 * bubble component with widget information to help users to understand the 
 * visualization.
 */
export default {
    name: 'WidgetHeader',
    props: {
        title: {
            type: String,
            required: true
        },
        important: {
            type: Boolean,
            default: false
        },
        info: {
            type: String,
            default: null
        },
        bigHeader: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        show: false
    })
}
</script>

<style scoped>
.v-tooltip__content {
  opacity: 1 !important;
}

.card-title {
    font-size: 1.02em;
}
</style>